import { atom, type PrimitiveAtom } from "jotai";

export const remoteClientDataAtom: PrimitiveAtom<Record<string, any>> =
  atom<Record<string, any>>({});
